module.exports = __webpack_public_path__ + "img/down-arrow.99340c47.svg";